export const ADD_RECENTLY_APP = 'ADD_RECENTLY_APP'
export const UPDATE_RECENTLY_APP = 'UPDATE_RECENTLY_APP'
export const REMOVE_RECENTLY_APP = 'REMOVE_RECENTLY_APP'
export const INIT_RECENTLY_APP = 'INIT_RECENTLY_APP'
